
//import firebase from "firebase";
import {auth} from "@/scripts/firebase"
import { NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins, Watch } from "vue-property-decorator";
import {toHiragana,toZenKana} from 'jaconv'
import Common from '../mixins/common';
import { CreateAccountArg } from "@/common-datatypes";


@Component({
  components: {
    
  }
})

export default class Introduction extends Mixins(Common) {
  isLoading = false

  defaultAccountData: CreateAccountArg = {
    lastName: '',
    firstName: '',
    lastNameYomigana: '',
    firstNameYomigana: '',
    schoolName: '',
    lang: '',
    timeZone: ''
  }

  accountData: CreateAccountArg = {
    ...this.defaultAccountData
  }

  notice = {} as NoticeProps

  get observer(){
    return this.$refs.setUpValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return (this.accountData.lastName && this.accountData.firstName && this.accountData.schoolName) ? false : true
  }

  @Watch('accountData',{deep: true})
  async changeAccountData(newVal: CreateAccountArg){

    if(newVal.lastNameYomigana){
      newVal.lastNameYomigana = toHiragana(toZenKana(newVal.lastNameYomigana))
      newVal.lastNameYomigana = (newVal.lastNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }

    if(newVal.firstNameYomigana){
      newVal.firstNameYomigana = toHiragana(toZenKana(newVal.firstNameYomigana))
      newVal.firstNameYomigana = (newVal.firstNameYomigana as string).replace(/[^\u3041-\u3096]/g,'')
    }
  }

  async created(){
    console.trace('created');
  }
 
 async mounted(){
  console.trace('mounted')
 }

  destroyed() {
    console.trace('destroyed');
  }

  public async createAccount() {
    try{
      this.notice = {
        isShow: false,
      }

      if(! await this.observer.validate()){
        return
      }

      this.$store.commit("setLoading",true);
      this.isLoading = true

      const data: CreateAccountArg = {
        ...this.accountData,
        lang: this.$store.getters.lang,
        timeZone: this.$defaultTimeZone
      }

      await this.$createAccount(data)
      await auth.currentUser?.getIdToken(true)

      this.notice = {
        message: this.$t('introduction.setUpIsComplete') as string,
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }

      this.accountData = {
        ...this.defaultAccountData
      }

      this.observer.reset()
        //ダッシュボードへ移動
      this.$router.push({name: 'dashboard'})
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('signUp.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
    }
  }
}
